import React, { useEffect, useState, useRef, useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Navigation } from 'swiper/modules';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from './../../firebase/firebaseConfig';
import { CartContext } from './../contexts/CartContext';
import { FavoriteContext } from './../contexts/FavoriteContext';

const BestSelling = () => {
    const [bestSelling, setBestSelling] = useState([]);
    const [loading, setLoading] = useState(true);
    const bestSellingRef = useRef(null);
    const { addToCart } = useContext(CartContext);
    const { favorites, addFavorite, removeFavorite } = useContext(FavoriteContext);

    useEffect(() => {
        const fetchBestSelling = async () => {
            try {
                const q = query(collection(db, 'Products'), orderBy('sold', 'desc'), limit(9));
                const querySnapshot = await getDocs(q);
                const products = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
                setBestSelling(products);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching best-selling products:', error);
                setLoading(false);
            }
        };
        fetchBestSelling();
    }, []);

    const handlePrevBestSelling = useCallback(() => {
        if (!bestSellingRef.current) return;
        bestSellingRef.current.swiper.slidePrev();
    }, []);

    const handleNextBestSelling = useCallback(() => {
        if (!bestSellingRef.current) return;
        bestSellingRef.current.swiper.slideNext();
    }, []);

    const handleAddToCart = (product) => {
        const item = {
            id: product.id,
            name: product.name,
            price: product.price,
            images: product.images,
            quantity: 1,
            color: product.colors ? product.colors[0] : null,
            size: product.sizes ? product.sizes[0] : null,
        };
        addToCart(item);
    };

    const handleToggleFavorite = (product) => {
        if (favorites.some(item => item.id === product.id)) {
            removeFavorite(product.id);
        } else {
            addFavorite(product);
        }
    };

    return (
        <div className="best-selling my-5 container">
            <div className="d-flex justify-content-between">
                <h3 className="nunito-sans fw-bold black-bordered-bottom">BEST SELLING</h3>
                <div className='d-flex'>
                    <div className="prev-arrow" onClick={handlePrevBestSelling} style={{ cursor: "pointer" }}>
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="2em" width="2em" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 010 .708L5.707 8l5.647 5.646a.5.5 0 01-.708.708l-6-6a.5.5 0 010-.708l6-6a.5.5 0 01.708 0z" clipRule="evenodd"></path>
                        </svg>
                    </div>
                    <div className="next-arrow" onClick={handleNextBestSelling} style={{ cursor: "pointer" }}>
                          <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="2em" width="2em" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.646 1.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L10.293 8 4.646 2.354a.5.5 0 010-.708z" clipRule="evenodd"></path></svg>
                    </div>
                </div>
            </div>
            <div className='mt-5'>
                {loading ? (
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <Swiper
                        slidesPerView={3}
                        spaceBetween={30}
                        modules={[Navigation]}
                        ref={bestSellingRef}
                        breakpoints={{
                            1200: {
                                slidesPerView: 3,
                            },
                            0: {
                                slidesPerView: 1,
                            },
                        }}
                        className="mySwiper"
                    >
                        {bestSelling.length > 0 ? (
                            bestSelling.map((product) => (
                                <SwiperSlide key={product.id}>
                                    <div className='p-card-wrap'>
                                        <Link to={`/p/${product.id}`} className="p-card-link">
                                            <div className="p-card">
                                                <img src={product.images ? product.images[0] : ''} alt={product.name} />
                                                <div className="p-card-details d-flex px-3 justify-content-start flex-column" style={{ textAlign: "left" }}>
                                                    <h6 className="fw-bold mt-2 nunito-2">{product.name}</h6>
                                                    <p className='nunito-2'>₦{product.price}</p>
                                                </div>
                                            </div>
                                        </Link>
                                        <div className="d-flex justify-content-between align-items-center p-3">
                              <div>
                                  <Link to={`/p/${product.id}`} className='black-bordered-button'>
                                    View
                                  </Link>
                              </div>
                              <div className='d-flex'>
                                    
                                    <button style={{ color: 'white', cursor: 'pointer', backgroundColor: 'black', borderRadius: '50%', padding: '10px', margin: '0 .3vw' }} className="d-flex align-content-center border-rounded" onClick={() => handleAddToCart(product)}>
                                      <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M14 5H2v9a1 1 0 001 1h10a1 1 0 001-1V5zM1 4v10a2 2 0 002 2h10a2 2 0 002-2V4H1z" clipRule="evenodd" />
                                        <path d="M8 1.5A2.5 2.5 0 005.5 4h-1a3.5 3.5 0 117 0h-1A2.5 2.5 0 008 1.5z" />
                                      </svg>
                                    </button>
                                    <button className="d-flex justify-content-center align-items-center p-2 border-0" style={{ color: 'black', cursor: 'pointer', backgroundColor: 'white', borderRadius: '50%' }} onClick={() => handleToggleFavorite(product)}>
                                        {favorites.some(item => item.id === product.id) ? (
                                          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path></svg>
                                            
                                            
                                            
                                        ) : (
                                          <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                                            </svg>
                                        )}
                                    </button>
                              </div>
                              
                            </div>
                                    </div>
                                </SwiperSlide>
                            ))
                        ) : (
                            <p>No best-selling products found.</p>
                        )}
                    </Swiper>
                )}
            </div>
        </div>
    );
};

export default BestSelling;
